const NavTab = ({clinic}) => {

    return ( 
        <>
         <nav className="navbar bg-light p-4 mb-0">
                    <div className="container-fluid d-flex justify-content-around">
                        <div className="navbar-brand">
                            {clinic.logo?<div className='navbar-brand'>
                                <img src={clinic.logo} alt='logo' width='100%'/>
                            </div>:<h1>{clinic.name}</h1>}
                        </div>
                        <div className="d-flex flex-column">

                            <span>{clinic.name}</span>
                            <span>{clinic.street}</span>
                            <span>{clinic.city}. {clinic.province}-{clinic.postalCode}</span>
                            <span>{clinic.phone}</span>

                        </div>
                    </div>
                </nav>
                <hr className="border border-primary border-3 opacity-75 mt-0" />
        </>
     );
}
 
export default NavTab;